import { useState } from "react";
import axios from "axios";

const useTokenInfo = () => {
    // 이제 총 토큰만 관리
    const [tokenInfo, setTokenInfo] = useState({
        total: 0,
    });
    const [initialTokenTotal, setInitialTokenTotal] = useState(null);
    const [isTokenDeducted, setIsTokenDeducted] = useState(false);

    // ✅ 총 토큰만 받아서 상태 갱신
    const updateTokenInfo = (totalRaw) => {
        const total = Number.isFinite(totalRaw) ? totalRaw : 0;

        setTokenInfo({
            total,
        });
    };

    // ✅ GET /ticket/token → remaining_tokens_total 사용
    const fetchTokenInfo = async () => {
        try {
            const user_id = parseInt(localStorage.getItem("user_id"));
            const res = await axios.get(
                `${process.env.REACT_APP_FASTAPI_ADS_URL}/ticket/token`,
                { params: { user_id } }
            );

            const total = Number(res.data.remaining_tokens_total) || 0;

            updateTokenInfo(total);
            setInitialTokenTotal(total);

            return total;
        } catch (err) {
            console.error("토큰 정보 조회 실패", err);
        }
    };

    // ✅ 토큰 차감: POST 후 다시 fetch 해서 동기화
    const deductToken = async (total) => {
        if (!Number.isFinite(total) || total <= 0) {
            throw new Error("잔여 토큰 없음");
        }

        try {
            const user_id = parseInt(localStorage.getItem("user_id"));
            await axios.post(
                `${process.env.REACT_APP_FASTAPI_ADS_URL}/ticket/token/deduct`,
                { user_id },
                { headers: { "Content-Type": "application/json" } }
            );

            // const { used_type, remaining_tokens } = res.data;
            // console.log("🔹 차감 결과:", used_type, remaining_tokens);

            // 차감 후 총 토큰 다시 조회 (백엔드 기준으로 싱크)
            const newTotal = await fetchTokenInfo();

            setIsTokenDeducted(true);
            return newTotal;
        } catch (err) {
            console.error("토큰 차감 실패", err);
            alert("토큰 차감에 실패했습니다.");
        }
    };

    return {
        tokenInfo,          // tokenInfo.total 로 남은 토큰 사용
        initialTokenTotal,  // 최초 호출 시점 총 토큰
        isTokenDeducted,
        fetchTokenInfo,
        deductToken,
    };
};

export default useTokenInfo;
